<template>
  <v-menu
    offset-y
    top
    right
    nudge-top="15px"
    max-height="200px"
    :close-on-content-click="false"
    :disabled="items.length === 0"
    transition="slide-y-reverse-transition"
  >
    <template v-slot:activator="{ on }">
      <span v-on="on" class="pa-0" style="color: blue; cursor: pointer">{{items.length}} {{text}}</span>
    </template>
    <v-card min-height="200px">
      <v-simple-table
        :dense="true"
        :fixed-header="true"
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Date</th>
            <th class="text-left">Designator</th>
            <th class="text-left">Clinic</th>
            <th class="text-left">Employee</th>
            <th class="text-left"><v-btn dense x-small @click="clearSelectedList">Remove All</v-btn></th>
          </tr>
          </thead>
          <tbody class="body-2">
          <tr v-for="item in selectedItemList" :key="item.name">
            <td class="caption" style="width: 103px;">{{ item.date }}</td>
            <td class="caption text-center">{{ item.designator }}</td>
            <td class="caption">{{ item.clinicTitle }}</td>
            <td class="caption">{{ item.employeeName }}</td>
            <td class="caption text-center"><v-btn x-small icon @click="unSelectItem(item)"><v-icon>mdi-delete</v-icon></v-btn></td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </v-menu>
</template>

<script>
  export default {
    name: 'SelectedItemsInfo',
    props: ['items', 'text', 'unSelectItem', 'clearSelectedList'],
    computed: {
      selectedItemList () {
        return this.items.concat().sort(groupedSort)
        function groupedSort (a, b) {
          const aDate = a.date.substr(0, 10)
          const bDate = b.date.substr(0, 10)
          const aDesignator = a.designator
          const bDesignator = b.designator
          if (aDate === bDate) {
            return (aDesignator < bDesignator) ? -1 : (aDesignator > bDesignator) ? 1 : 0
          } else {
            return (new Date(aDate).getTime() < new Date(bDate).getTime()) ? -1 : 1
          }
        }
      }
    }
  }
</script>
